(() => {
  const root = document.querySelector('[data-solave-cookie]');
  if (!root || root.dataset.solaveCookieReady === 'true') return;
  root.dataset.solaveCookieReady = 'true';

  const categories = ['preferences', 'analytics', 'marketing'];
  const views = Array.from(root.querySelectorAll('[data-solave-cookie-view]'));
  const status = root.querySelector('[data-solave-cookie-status]');
  let privacyApi = null;
  let queuedSettingsOpen = false;

  function setView(name) {
    views.forEach((view) => {
      view.hidden = view.dataset.solaveCookieView !== name;
    });
    root.querySelectorAll('[data-solave-cookie-action="customize"]').forEach((button) => {
      button.setAttribute('aria-expanded', String(name === 'settings'));
    });
  }

  function readConsent() {
    if (!privacyApi || typeof privacyApi.currentVisitorConsent !== 'function') return {};
    try {
      return privacyApi.currentVisitorConsent() || {};
    } catch (error) {
      return {};
    }
  }

  function syncCategories() {
    const consent = readConsent();
    categories.forEach((category) => {
      const input = root.querySelector('[data-solave-cookie-category="' + category + '"]');
      if (input) input.checked = consent[category] === 'yes';
    });
  }

  function openSettings() {
    if (!privacyApi) {
      queuedSettingsOpen = true;
      return;
    }
    syncCategories();
    if (status) status.hidden = true;
    root.hidden = false;
    setView('settings');
    const firstChoice = root.querySelector('[data-solave-cookie-category="preferences"]');
    if (firstChoice) window.requestAnimationFrame(() => firstChoice.focus());
  }

  function closePanel() {
    root.hidden = true;
    setView('intro');
  }

  function setBusy(isBusy) {
    root.querySelectorAll('button').forEach((button) => {
      button.disabled = isBusy;
    });
  }

  function saveConsent(consent) {
    if (!privacyApi || typeof privacyApi.setTrackingConsent !== 'function') return;
    setBusy(true);
    if (status) status.hidden = true;
    try {
      privacyApi.setTrackingConsent(consent, () => {
        setBusy(false);
        closePanel();
        root.dispatchEvent(new CustomEvent('solave:consent-saved', {
          bubbles: true,
          detail: consent
        }));
      });
    } catch (error) {
      setBusy(false);
      if (status) status.hidden = false;
    }
  }

  root.addEventListener('click', (event) => {
    const button = event.target instanceof Element
      ? event.target.closest('[data-solave-cookie-action]')
      : null;
    if (!button || !root.contains(button)) return;

    switch (button.dataset.solaveCookieAction) {
      case 'accept':
        saveConsent({ preferences: true, analytics: true, marketing: true });
        break;
      case 'reject':
        saveConsent({ preferences: false, analytics: false, marketing: false });
        break;
      case 'customize':
        syncCategories();
        if (status) status.hidden = true;
        setView('settings');
        const firstChoice = root.querySelector('[data-solave-cookie-category="preferences"]');
        if (firstChoice) window.requestAnimationFrame(() => firstChoice.focus());
        break;
      case 'back':
        setView('intro');
        break;
      case 'save': {
        const consent = {};
        categories.forEach((category) => {
          const input = root.querySelector('[data-solave-cookie-category="' + category + '"]');
          consent[category] = Boolean(input && input.checked);
        });
        saveConsent(consent);
        break;
      }
      default:
        break;
    }
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest('[data-solave-cookie-open]')
      : null;
    if (!trigger) return;
    event.preventDefault();
    openSettings();
  });

  window.SolaveCookiePreferences = { open: openSettings };

  function initialize() {
    privacyApi = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacyApi) return;

    let shouldShow = false;
    let missingChoice = true;
    try {
      shouldShow = typeof privacyApi.shouldShowBanner === 'function'
        && privacyApi.shouldShowBanner();
      const consent = readConsent();
      missingChoice = categories.some((category) =>
        consent[category] !== 'yes' && consent[category] !== 'no'
      );
    } catch (error) {
      shouldShow = false;
    }

    if ((shouldShow && missingChoice) || root.dataset.preview === 'true') {
      root.hidden = false;
      setView('intro');
    }
    if (queuedSettingsOpen) openSettings();
  }

  function loadPrivacyApi(attempt) {
    const shopify = window.Shopify;
    if (!shopify || typeof shopify.loadFeatures !== 'function') {
      if (attempt < 40) window.setTimeout(() => loadPrivacyApi(attempt + 1), 250);
      return;
    }

    shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.2' }],
      (error) => {
        if (error) {
          if (attempt < 4) window.setTimeout(() => loadPrivacyApi(attempt + 1), 400);
          return;
        }
        initialize();
      }
    );
  }

  loadPrivacyApi(0);
})();